<template>
  <div>
    <div id="adbox" ref="adbox" v-show="showAdbox" @mouseenter="enterBox" @mouseleave="leaveBox">
      <a @click="more()">
        <img src="@/assets/mark.jpg" alt="广告图片">
      </a>
      <b @click="closeBox">Ⅹ</b>
    </div>
    <Header></Header>
    <nav>
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" style="width:1200px;margin: 0 auto;height: 39px">
        <el-menu-item index="1">国际化发展</el-menu-item>
        <el-menu-item index="2">北京市布局</el-menu-item>
      </el-menu>
    </nav>
    <div class="centerWidth100">
      <div class="Center1200">
        <div class="conHeader">
          <el-form :model="form" ref="form" label-width="100px" label-position="right">
            <el-form-item label="国家或地区：" class="width45">
              <el-select v-model="form.coverage" clearable filterable placeholder="请选择">
                <el-option v-for="(item,Key) in regionList" :key="Key" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="行业类别：" class="width45">
              <el-select v-model="form.industryType" clearable placeholder="请选择">
                <el-option v-for="(item,Key) in industryList" :key="Key" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="企业名称：" class="width45">
              <el-input v-model="form.name" placeholder="请输入企业名称"></el-input>
            </el-form-item>

            <el-form-item class="width6">
              <el-button type="primary" size="small" @click="render()" plain>查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="conBottom">
          <el-row class="tac">
            <el-col style="min-width:280px;max-height:682px">
              <el-menu
                :default-active="Flag == '' ? '1-0' : Flag + '-0'"
                :default-openeds="[Flag]"
                :unique-opened="true" class="el-menu-vertical-demo" background-color="#fbe1be" text-color="black"
                active-text-color="#731f36">
                <el-submenu index="3">
                  <template slot="title">
                    <span>会计咨询</span>
                  </template>
                  <el-menu-item-group style="max-height: 456px;overflow: hidden;overflow-y: auto;">
                    <el-menu-item v-for="(item, Key) in MenuList3" :key="Key" @click="clickMenu(item,'3')"
                                  :index="'1-' + Key">{{ item.name }}
                    </el-menu-item>
                    <el-menu-item v-if="MenuList3.length > 0" @click="more()">更多</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-submenu index="2">
                  <template slot="title">
                    <span>法律服务</span>
                  </template>
                  <el-menu-item-group style="max-height: 456px;overflow: hidden;overflow-y: auto;">
                    <el-menu-item v-for="(item, Key) in MenuList2" :key="Key" @click="clickMenu(item,'2')"
                                  :index="'2-' + Key">{{ item.name }}
                    </el-menu-item>
                    <el-menu-item v-if="MenuList2.length > 0" @click="more()">更多</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-submenu index="1">
                  <template slot="title">
                    <span>人力资源</span>
                  </template>
                  <el-menu-item-group style="max-height: 456px;overflow: hidden;overflow-y: auto;">
                    <el-menu-item v-for="(item, Key) in MenuList1" :key="Key" @click="clickMenu(item,'1')"
                                  :index="'3-' + Key">{{ item.name }}
                    </el-menu-item>
                    <el-menu-item v-if="MenuList1.length > 0" @click="more()">更多</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
                <el-submenu index="4">
                  <template slot="title">
                    <span>广告营销</span>
                  </template>
                  <el-menu-item-group style="max-height: 456px;overflow: hidden;overflow-y: auto;">
                    <el-menu-item v-for="(item, Key) in MenuList4" :key="Key" @click="clickMenu(item,'4')"
                                  :index="'4-' + Key">{{ item.name }}
                    </el-menu-item>
                    <el-menu-item v-if="MenuList4.length > 0" @click="more()">更多</el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </el-menu>
            </el-col>
          </el-row>
          <div class="Right">
            <div class="mapDivTop">
              <h2 v-if="MapDivTop.name">{{ MapDivTop.name }} <p v-if="MapDivTop.industryTypeName">
                {{ MapDivTop.industryTypeName }}</p></h2>
              <div v-if="MapDivTop.industryTypeName" @click="viewDetails">查看详情</div>
            </div>
            <div class="mapDiv" id="mapDiv">
              <div class="MapDiver">
                <div class='box'></div>
                <div class='box2'>业务覆盖范围示意图</div>
                <div class='box3'></div>
              </div>
            </div>
          </div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import {industriesApi, counterVyContinentIdApi, infosApi} from "@/api/show/Display";
import MapInit from '../../plugins/MapInit';
import Header from '@/components/header.vue';

export default {
  name: "Display",
  components: {
    Header
  },
  data() {
    return {
      activeIndex: '1',
      x: 50,
      y: 50,
      xin: true,
      yin: true,
      step: 1,
      delay: 10,
      itl: null,
      showAdbox: true,
      form: {//点击查询所需要的参数
        name: '',
        industryType: '',
        countryCode: '',
        coverage: ''
      },
      Flag: '',
      entCountryInfoVoList: [],//地图经纬度
      MapDivTop: {},//点击左侧菜单地图上方显示的参数
      MenuList1: [],//人力资源广告List
      MenuList2: [],//法律服务list
      MenuList3: [],//会计、咨询List
      MenuList4: [],//广告营销List
      industryList: [],//所有行业
      regionList: []//所有国家
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routeEnterShowAdbox()
    })
  },
  beforeRouteLeave(to, from, next) {
    next(vm => {
      vm.routeEnterShowAdbox()
    })
    clearInterval(this.itl);
  },
  created() {
    this.Flag = this.$route.query.type || '';
    industriesApi().then((res) => {//获取全部行业
      this.industryList[0] = res.data.data[2]
      this.industryList[1] = res.data.data[1]
      this.industryList[2] = res.data.data[0]
      this.industryList[3] = res.data.data[3]
    });
    counterVyContinentIdApi().then((res) => {//获取全部国家
      this.regionList = res.data.data
    });
    this.renderNavMenu();
  },
  methods: {
    initMap() {
      MapInit.init().then(
        T => {
          this.T = T
          const config = {
            pageCapacity: 5
          };
          this.map = new T.Map('mapDiv', config)
          this.map.centerAndZoom(new T.LngLat(116.401003, 39.903117), 3)
          if (this.entCountryInfoVoList.length) {
            this.randomShow(T)
          }
        }).catch()
    },
    randomShow(T) {
      let list = [];
      this.map.clearOverLays();
      for (let i = 0; i < this.entCountryInfoVoList.length; i++) {
        if (this.entCountryInfoVoList[i].coordinate !== null) {
          const lonlatArray = this.entCountryInfoVoList[i].coordinate.split(",")
          const lon = lonlatArray[0]
          const lat = lonlatArray[1]
          let latlng = new T.LngLat(lon, lat);
          list.push(latlng);
          let label = new T.Label({
            text: this.entCountryInfoVoList[i].name,
            position: latlng,
            offset: new T.Point(0, -20)
          });
          const marker = new T.Marker(latlng)
          this.map.addOverLay(marker)
          this.map.addOverLay(label);
        }
      }
      let bestViewport = this.map.getViewport(list)
      if (this.entCountryInfoVoList.length < 2) {
        bestViewport.zoom = 3
      }
      this.map.centerAndZoom(bestViewport.center, bestViewport.zoom);
    },
    render() {
      this.Flag = '';
      this.renderNavMenu();
    },
    // 进入页面调用左侧菜单
    renderNavMenu() {
      this.MenuList1 = [];
      this.MenuList2 = [];
      this.MenuList3 = [];
      this.MenuList4 = [];
      let data = this.form
      for (let val in data) {
        if (data[val] == '') {
          delete data[val];
        }
      }
      infosApi({
        params: data
      }).then((res) => {
        var data = res.data.data;
        if (data.length === 0) {
          this.entCountryInfoVoList = ''
          this.MapDivTop = {
            name: '此条件暂无数据'
          }
        }
        for (let i = 0; i < data.length; i++) {
          this['MenuList' + [data[i].industryType]].push(data[i])
        }
        if (this.MenuList3.length && (this.Flag == '' || this.Flag == 1)) {
          this.Flag = 1;
          this.MapDivTop = this.MenuList3[0];
          this.entCountryInfoVoList = this.MenuList3[0].entCountryInfoVoList;
        } else if (this.MenuList2.length && (this.Flag == '' || this.Flag == 2)) {
          this.Flag = 2;
          this.MapDivTop = this.MenuList2[0];
          this.entCountryInfoVoList = this.MenuList2[0].entCountryInfoVoList;
        } else if (this.MenuList1.length && (this.Flag == '' || this.Flag == 3)) {
          this.Flag = 3;
          this.MapDivTop = this.MenuList1[0];
          this.entCountryInfoVoList = this.MenuList1[0].entCountryInfoVoList;
        } else if (this.MenuList4.length && (this.Flag == '' || this.Flag == 4)) {
          this.Flag = 4;
          this.MapDivTop = this.MenuList4[0];
          this.entCountryInfoVoList = this.MenuList4[0].entCountryInfoVoList;
        }
        this.initMap();
      });
    },
    // 点击左侧菜单调用获取地图数据
    clickMenu(val, Index) {
      this.Flag = Index;
      this.MapDivTop = val;
      this.entCountryInfoVoList = val.entCountryInfoVoList;
      this.randomShow(this.T);
    },
    more() {
      this.$router.push({path: '/show/more', query: {}});
      // let routeData = this.$router.resolve({path: '/show/more', query: {}});
      // window.open(routeData.href, '_blank');
    },
    viewDetails() {
      this.$router.push({path: '/ent/info', query: {id: this.MapDivTop.id}});
      // let routeData = this.$router.resolve({path: '/ent/info', query: {id: this.MapDivTop.id}});
      // window.open(routeData.href, '_blank');
    },
    closeBox() {
      this.showAdbox = false;
      clearInterval(this.itl)
    },
    leaveBox() {
      if (this.showAdbox == false) {
        clearInterval(this.itl)
      } else {
        this.itl = setInterval(this.movebox, this.delay)
      }
    },
    enterBox() {
      clearInterval(this.itl)
    },
    movebox() {
      var L = 0;
      var T = 0;
      var R = document.documentElement.clientWidth - this.$refs.adbox.offsetWidth;    //浏览器显示宽度-adbox宽度，不随滚动条变化而变化
      var B = document.documentElement.clientHeight - this.$refs.adbox.offsetHeight;  //浏览器显示高度-adbox高度，不随滚动条变化而变化
      this.$refs.adbox.style.left = this.x + document.documentElement.scrollLeft + "px";  //adbox初始左+滚动条最左端到浏览器最左端的距离
      this.$refs.adbox.style.top = this.y + document.documentElement.scrollTop + "px";    //adbox初始高+滚动条顶端到浏览器顶端的距离
      this.x = this.x + this.step * (this.xin ? 1 : -1);
      if (this.x < L) {
        this.xin = true;
        this.x = L;
      }
      if (this.x > R) {
        this.xin = false;
        this.x = R;
      }
      this.y = this.y + this.step * (this.yin ? 1 : -1);
      if (this.y < T) {
        this.yin = true;
        this.y = T;
      }
      if (this.y > B) {
        this.yin = false;
        this.y = B;
      }
    },
    routeEnterShowAdbox() {
      this.itl = setInterval(this.movebox, this.delay)
    },
    handleSelect(val) {
      if(val == 1) {
        this.$router.push({path: '/show/map',query:{}});
      } else{
        this.$router.push({path: '/show/mapbj',query:{}});
      }
    },
  }
}
</script>

<style scoped>
nav .el-menu-demo, .el-menu--horizontal, .el-menu {
  background: hsla(0,0%,100%,0)!important;
}
.el-menu--horizontal>.el-menu-item{
  padding: 0px 44px;
  font-size: 20px;
  height: 59px;
  line-height: 59px;
}
.el-menu-demo li {
  background: #BA0132 !important;
  color: white !important;
}
.el-menu-demo li:hover {
  background: #BA0132 !important;
}
.el-menu.el-menu--horizontal{
  border: none !important;
}
.el-menu--horizontal>.el-menu-item.is-active {
  border-bottom: 1px solid white !important;
  background: #990012 !important;
}
.headCenter {
  height: 100%;
  display: flex;
  align-items: center;
  color: white;
  font-size: 24px;
  font-family: '方正正中黑简体';
}

.Center1200 {
  width: 1200px;
  margin: 0 auto;
}

.mapDiv {
  width: 100%;
  height: 600px;
}

.searchForm {
  width: 700px;
}

nav {
  height: 60px !important;
  background: #BA0132;
}

nav a {
  font-size: 14px;
  color: white;
}

.conHeader {
  width: 100%;
  border-bottom: 1px solid #D7D7D7;
  padding: 15px 0;
  margin-bottom: 30px;
}

form {
  display: flex;
  align-items: center;
}

.width45 {
  width: 28.6%;
  margin: 0;
}

.width6 {
  width: 6%;
  margin: 0;
}

form > div .el-form-item__label {
  width: 100px;
}

.conBottom {
  display: flex;
}

.Right {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 20px;
}

.mapDivTop {
  width: 100%;
  height: 60px;
  border: 1px solid rgb(252, 225, 189);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mapDivTop > h2 {
  margin-left: 20px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mapDivTop h2 > p {
  width: 64px;
  height: 16px;
  font-size: 14px;
  color: rgb(249, 177, 144);
  background: rgb(253, 240, 220);
  padding: 3px 8px;
  margin: 0px 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mapDivTop > span {
  font-size: 14px;
}

.mapDivTop > div {
  width: 100px;
  height: 100%;
  font-size: 14px;
  margin-right: -1px;
  color: #A30014;
  background: rgb(252, 225, 189);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.el-menu ul li,
.el-menu {
  background: white !important;
}

.mapDiv {
  position: relative;
}

.MapDiver {
  font-size: 20px;
  color: white;
  position: absolute;
  left: 30%;
  z-index: 499;
  display: flex;
}

.box, .box3 {
  width: 0;
  height: 0;
  border-top: 30px solid rgb(245, 154, 35);
  border-right: 30px solid rgba(0, 0, 0, 0);
  border-bottom: 30px solid rgba(0, 0, 0, 0);
  border-left: 30px solid rgba(0, 0, 0, 0);
  margin-top: -30px;
}

.box2 {
  width: 230px;
  height: 30px;
  background-color: rgb(245, 154, 35);
  line-height: 30px;
}

.box {
  transform: translate(30px, 30px);
}

.box3 {
  transform: translate(-30px, 30px);
}

.el-menu-item-group > ul {
  max-height: 445px !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}

#adbox {
  width: 231px;
  position: absolute;
  z-index: 999;
}

#adbox img {
  border: none;
  cursor: pointer;
}

#adbox b {
  position: absolute;
  right: 5px;
  top: 0;
  cursor: pointer;
  color: white;
}
.centerWidth100{
  width: 100%;
  position: relative;
}
</style>
